import React from 'react';
import './Levels.css';

const Levels = () => {
  return (
    <section className="levels-section" aria-label="Chamada para contratação">
      <div className="levels-card">
        <div className="levels-text">
          <span>Atendimento rápido pelo WhatsApp</span>
          <h3>Pronto para mudar de nível?</h3>
          <p>Fale com a VitaLink e descubra o plano perfeito para sua rotina.</p>
        </div>
        <a
          href="https://wa.me/31990870412?text=Olá! Quero consultar cobertura e contratar um plano VitaLink."
          className="levels-button"
          target="_blank"
          rel="noopener noreferrer"
        >
          Falar com consultor
        </a>
      </div>
    </section>
  );
};

export default Levels;
